<div id="editUsers" class="subBlockContainer entry-loader">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">
      <div  *ngIf="loadContent" class="inner-subBlock-wrapper">

        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->

        <div class="row">
          <div class="col-md-6" [formGroup]="userFormGroup" style="margin-top: 10px;">
            <div class="userinfo" formGroupName="userGroup">
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="loginNameValidate" formControlName="loginName" placeholder="LOGIN NAME">
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="firstNameValidate" formControlName="firstName" placeholder="FIRST NAME">
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="lastNameValidate" formControlName="lastName" placeholder="LAST NAME">
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="emailValidate" formControlName="email" placeholder="EMAIL">
              </mat-form-field>
              <!-- <mat-form-field [floatLabel]="'always'">
                <input matInput class="passwordValidate" [type]="hide ? 'password' : 'text'" formControlName="password" placeholder="NEW PASSWORD" pattern="[^' ']+">
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field> -->
            </div>
            <password [showOldPassword]="false" [showConfirmPassword]="false" 
            (isValidPassword)="checkIsValidPassoword($event);" 
            (newPassword)="getNewPassword($event)"></password>
          </div>

          <div class="col-md-6 padding-l-x80">
            <div class="page-title-wrapper">
              <div class="page-title-position accesslevel">
                  SUBSCRIPTIONS
              </div>
            </div>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedPromotions">
              Promotions
            </mat-checkbox>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedDatafeedsCsv" >
              Datafeeds - CSV
            </mat-checkbox>
            <!-- <mat-checkbox [(ngModel)]="checkedDatafeedsXml" style="display: block;margin-left: 18px;">
              Datafeeds - XML
            </mat-checkbox> -->
            <div class="pagepage-title-wrapper">
              <div class="page-title-position accesslevel">
                  SALES DOCUMENTS
              </div>
            </div>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedInvoices" >
              Invoices PDF
            </mat-checkbox>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedOrderConfirmations" >
              Order Confirmations
            </mat-checkbox>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedOrderStatusUpdates" >
              Order Status Updates
            </mat-checkbox>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedBackorderETAUpdates" >
              Backorder ETA Updates
            </mat-checkbox>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedAnnuityExpiryNotifications" >
              Annuity Expiry Notifications
            </mat-checkbox>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedShippingReports" >
              Shipping Reports
            </mat-checkbox>
            <mat-checkbox class="mat-checkbox" [(ngModel)]="checkedStatements">
              Statements
            </mat-checkbox>

            <div class="page-title-wrapper">
              <div class="page-title-position accesslevel">
                ACCESS LEVEL
              </div>
            </div>

            <!-- <mat-slide-toggle class="manage-level1" checked>View Access
              <div class="font-x10">
                Can view the website and is unable to complete transactions</div>
            </mat-slide-toggle> -->
            <mat-slide-toggle class="manage-level1" [(ngModel)]="purchaseChecked">Purchase Access
              <div class="font-x10">
                Can view and purchase products on behalf of this account</div>
            </mat-slide-toggle>
            <mat-slide-toggle id="third-toggle" class="manage-level2" [(ngModel)]="adminChecked">Admin Access
              <div class="font-x10">Can
                create and maintain user access</div>
            </mat-slide-toggle>
          </div>
        </div>
        <div class="button-wrapper align-center margin-t-x80">
          <button class="button button-red button-large saveuser" (click)="saveUser()">Save</button>
          <button class="deleteuser" (click)="deleteUser()">Delete</button>
        </div>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth="684" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>
</div>
<router-outlet></router-outlet>